import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
// import Home from './views/Home.vue';

Vue.use(Router);

// for public
const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.tokenscr) {
    next();
    return;
  } else {
    next('/');
  }
};
// for user
const ifAuthenticated = (to, from, next) => {
  if (store.getters.tokenscr) {
    next();
    return;
  }
  next('/login');
};
// for user
const ifAuthenticatedUser = (to, from, next) => {
  if (store.getters.tokenscr) {
    if (store.getters.userrole === 'user') {
      next();
      return;
    } else {
      next('/home');
    }
  }
  next('/login');
};
// for company
const ifAuthenticatedCompany = (to, from, next) => {
  if (store.getters.tokenscr) {
    if (store.getters.userrole === 'company') {
      next();
      return;
    } else {
      next('/');
    }
  }
  next('/login');
};
// for jobseeker
const ifAuthenticatedJs = (to, from, next) => {
  if (store.getters.tokenscr) {
    if (store.getters.userrole === 'jobseeker') {
      next();
      return;
    } else {
      next('/');
    }
  }
  next('/login');
};
// for admin
const ifAuthenticatedAdmin = (to, from, next) => {
  if (store.getters.tokenscr) {
    if (store.getters.userrole === 'admin') {
      next();
      return;
    } else {
      next('/atlet/detail');
    }
  }
  next('/login');
};

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Landing',
      component: () => import('./views/Landing.vue'),
    },
    {
      path: '/news/detail',
      name: 'NewsDetail',
      component: () => import('./views/Newsdetail.vue'),
    },
    {
      path: '/about/info',
      name: 'News',
      component: () => import('./views/News.vue'),
    },
    {
      path: '/jobs',
      name: 'Jobs',
      component: () => import('./views/Jobs.vue'),
    },
    {
      path: '/education',
      name: 'Education',
      component: () => import('./views/Education.vue'),
    },
    {
      path: '/research',
      name: 'Research',
      component: () => import('./views/Research.vue'),
    },
    {
      path: '/community',
      name: 'Community',
      component: () => import('./views/Community.vue'),
    },
    {
      path: '/pkkmb',
      name: 'Pkkmb',
      component: () => import('./views/Pkkmb.vue'),
    },
    {
      path: '/campus-life',
      name: 'Campuslife',
      component: () => import('./views/Campuslife.vue'),
    },
    {
      path: '/job-detail',
      name: 'Jobdetail',
      component: () => import('./views/Jobdetail.vue'),
    },
    {
      path: '/companies',
      name: 'Company',
      component: () => import('./views/Company.vue'),
    },
    {
      path: '/data-al',
      name: 'Data',
      component: () => import('./views/Data.vue'),
    },
    {
      path: '/company-detail',
      name: 'Companydetail',
      component: () => import('./views/Companydetail.vue'),
    },
    {
      path: '/jurusan/:slug',
      name: 'Jurusan',
      props: true,
      component: () => import('./views/Jurusan.vue'),
    },
    {
      path: '/prodi/:slug',
      name: 'Prodi',
      props: true,
      component: () => import('./views/Prodi.vue'),
    },
    {
      path: '/verifyuser',
      name: 'Verifyuser',
      component: () => import('./views/Verifyuser.vue'),
    },
    {
      path: '/about',
      name: 'About',
      component: () => import('./views/About.vue'),
    },
    {
      path: '/about/contact',
      name: 'Contact',
      component: () => import('./views/Contact.vue'),
    },
    {
      path: '/pmb/daya-tampung',
      name: 'Dayatampung',
      component: () => import('./views/pages/Dayatampung.vue'),
    },
    {
      path: '/pmb/pengaduan-pmb',
      name: 'Pengaduanpmb',
      component: () => import('./views/pages/Pengaduanpmb.vue'),
    },
    {
      path: '/pmb/jalur-pmb/:slug',
      name: 'Jalurpenerimaan',
      props: true,
      component: () => import('./views/pages/Jalurpenerimaan.vue'),
    },
    {
      path: '/gallery',
      name: 'Gallery',
      component: () => import('./views/Gallery.vue'),
    },
    {
      path: '/registration',
      name: 'Register',
      component: () => import('./views/Register.vue'),
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: '/home',
      name: 'Home',
      // component: () => import('./views/Home.vue'),
      component: () => import('./views/admin/Info.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('./views/Login.vue'),
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: '/forget-password',
      name: 'Forgetpass',
      component: () => import('./views/Forgetpass.vue'),
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: '/help',
      name: 'Help',
      component: () => import('./views/Help.vue'),
    },
    {
      path: '/surat',
      name: 'SuratGuest',
      component: () => import('./views/guest/Surat.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/change-password',
      name: 'Changepassword',
      component: () => import('./views/Changepass.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/admin/atlet',
      name: 'PendudukAdmin',
      component: () => import('./views/admin/Penduduk.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '/admin/atlet/detail',
      name: 'PendudukDetailAdmin',
      component: () => import('./views/admin/Pendudukdetail.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '/atlet/detail',
      name: 'PendudukDetail',
      component: () => import('./views/guest/Pendudukdetail.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/admin/surat',
      name: 'SuratAdmin',
      component: () => import('./views/admin/Surat.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '/admin/surat/:kodesurat',
      name: 'SuratDetailAdmin',
      props: true,
      component: () => import('./views/admin/Suratdetail.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '/admin/jenissurat',
      name: 'JenissuratAdmin',
      component: () => import('./views/admin/Jenissurat.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '/admin/jenispenduduk',
      name: 'JenispendudukAdmin',
      component: () => import('./views/admin/Jenispenduduk.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '/admin/jeniskerja',
      name: 'JeniskerjaAdmin',
      component: () => import('./views/admin/Jeniskerja.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '/admin/olahraga',
      name: 'JenisolgaAdmin',
      component: () => import('./views/admin/Jenisolga.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '/admin/banjar',
      name: 'BanjarAdmin',
      component: () => import('./views/admin/Banjar.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '/admin/info',
      name: 'Infoadmin',
      component: () => import('./views/admin/Info.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '/admin/journal',
      name: 'Journaladmin',
      component: () => import('./views/admin/Journal.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '/admin/product',
      name: 'Productadmin',
      component: () => import('./views/admin/Product.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '/admin/mitra',
      name: 'Mitraadmin',
      component: () => import('./views/admin/Mitra.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '/admin/jurusan',
      name: 'JurusanAdmin',
      component: () => import('./views/admin/Jurusan.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '/admin/prodi',
      name: 'ProdiAdmin',
      component: () => import('./views/admin/Prodi.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '/company/dashboard',
      name: 'DashboardCom',
      component: () => import('./views/company/Dashboard.vue'),
      beforeEnter: ifAuthenticatedCompany,
    },
    {
      path: '/company/jobs',
      name: 'JobsCompany',
      component: () => import('./views/company/Jobs.vue'),
      beforeEnter: ifAuthenticatedCompany,
    },
    {
      path: '/company/jobseeker',
      name: 'JobseekerCompany',
      component: () => import('./views/company/Jobseeker.vue'),
      beforeEnter: ifAuthenticatedCompany,
    },
    {
      path: '/company/profile',
      name: 'ProfileCompany',
      component: () => import('./views/company/Profile.vue'),
      beforeEnter: ifAuthenticatedCompany,
    },
    {
      path: '/company/job-detail',
      name: 'JobdetailCompany',
      component: () => import('./views/company/Jobdetail.vue'),
      beforeEnter: ifAuthenticatedCompany,
    },
    {
      path: '/jobseeker/profile',
      name: 'ProfileJs',
      component: () => import('./views/jobseeker/Profile.vue'),
      beforeEnter: ifAuthenticatedJs,
    },
    {
      path: '/jobseeker/dashboard',
      name: 'DashboardJs',
      component: () => import('./views/jobseeker/Dashboard.vue'),
      beforeEnter: ifAuthenticatedJs,
    },
    {
      path: '/study-with-pnb',
      name: 'Study',
      component: () => import('./views/Study.vue'),
    },
    {
      path: '/study-with-pnb/course',
      name: 'Course',
      component: () => import('./views/Course.vue'),
    },
    {
      path: '/study-with-pnb/course/regular',
      name: 'Coursereg',
      component: () => import('./views/Coursereg.vue'),
    },
    {
      path: '/study-with-pnb/course/international',
      name: 'Courseint',
      component: () => import('./views/Courseint.vue'),
    },
    {
      path: '/study-with-pnb/course/cooperation',
      name: 'Coursecoop',
      component: () => import('./views/Coursecoop.vue'),
    },
    {
      path: '/study-with-pnb/course/rpl',
      name: 'Courserpl',
      component: () => import('./views/Courserpl.vue'),
    },
    {
      path: '/study-with-pnb/course/specialization',
      name: 'Coursespe',
      component: () => import('./views/Coursespe.vue'),
    },
    {
      path: '/campus-life/alumni',
      name: 'Alumni',
      component: () => import('./views/Alumni.vue'),
    },
    {
      path: '/cooperation',
      name: 'Cooperation',
      component: () => import('./views/Cooperation.vue'),
    },
    {
      path: '/cooperation/research-collaboration',
      name: 'Collaboration',
      component: () => import('./views/Collaboration.vue'),
    },
    {
      path: '/cooperation/our-partners',
      name: 'Partner',
      component: () => import('./views/Partner.vue'),
    },
    {
      path: '*',
      name: 'Notfound',
      component: () => import('./views/Notfound.vue'),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0, behavior: 'smooth' };
    }
  },
});
